module.exports = import("https://threejsfundamentals.org/threejs/resources/threejs/r132/build/three.module.js");;